import { render, staticRenderFns } from "./addressInfo copy.vue?vue&type=template&id=10d13580&scoped=true"
import script from "./addressInfo copy.vue?vue&type=script&lang=js"
export * from "./addressInfo copy.vue?vue&type=script&lang=js"
import style0 from "./addressInfo copy.vue?vue&type=style&index=0&id=10d13580&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d13580",
  null
  
)

export default component.exports